<template>
    <router-view/>
  </template>
  <script>
  export default {
      beforeRouteUpdate(to, from, next) {
          if(to.name == 'integracao'){
              next({ name: 'integracao-list' })
          }else{
              next()
          }
      },
      created() {
          if(this.$route.name == 'integracao'){
              this.$router.push({ name: 'integracao-list' })
          }
      }
  }
  </script>